import { screenSmMin } from '@spotify-internal/encore-foundation';
import { browserFocusReset, rootStyle } from "../../styles/index.mjs";
import { TypeListItem as Item } from "../TypeListItem/index.mjs";
import styled from "../../styled-components.mjs";
export var ListItem = styled(Item).attrs({
  variant: 'bodyMedium',
  condensed: true,
  listStyleReset: true
}).withConfig({
  displayName: "ListItem",
  componentId: "sc-36ddnp-0"
})(["", ";max-inline-size:100%;display:inline-block;&:not(:last-child){margin-inline-end:18px;}", " @media (min-width:", "){float:left;[dir='rtl'] &{float:right;}}"], rootStyle(), browserFocusReset, screenSmMin);